import type { StyleSystemProps, CSSObject } from '@withjoy/joykit';
import { styled, Box } from '@withjoy/joykit';
import { animationTransition } from '@shared/utils/animationTransition';

export const StyledSwatch = styled(Box)``;
export const StyledSwatchFrame = styled(Box)``;

export const StyledArrowButton = styled(Box)<{ $dir: 'left' | 'right' }>`
  grid-area: ${props => `${props.$dir}Arrow`};
`;

export const ColorSwatchContainer = styled(Box)<{ $nextPos: number | undefined }>`
  transform: ${({ $nextPos = 0 }) => `translateX(${$nextPos}px)`};
`;

export const ColorSwatchContent = styled(Box)``;

const arrowButtonStyles: CSSObject = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  position: 'absolute',
  top: 0,
  zIndex: 1,
  color: 'mono14',
  background: 'white',
  width: '2rem',
  height: '2rem',
};

const colorCarouselStyles: StyleSystemProps = {
  position: 'relative',
  height: '40px',
  width: '100%',
  _after: {
    content: '" "',
    position: 'absolute',
    zIndex: 2,
    top: 0,
    left: -1,
    width: '2px',
    height: 7,
    backgroundColor: 'white',
  },
};

const colorCarouselContainerStyles: StyleSystemProps = {
  position: 'relative',
  flexDirection: 'row',
  height: '100%',
  paddingTop: 1,
  paddingBottom: 2,
  overflowX: 'hidden',
  _after: {
    content: '" "',
    position: 'absolute',
    zIndex: 2,
    top: 0,
    right: -1,
    width: '2px',
    height: 7,
    backgroundColor: 'white',
  },
};

const colorSwatchContainerStyles: StyleSystemProps = {
  display: 'flex',
  position: 'absolute',
  transition: 'transform 0.7s cubic-bezier(0.22, 0.61, 0.36, 1)',
};

const ColorSwatchContentStyles: StyleSystemProps = {
  width: '100%',
};

const ColorSwatchContentOverStyles: StyleSystemProps = {
  width: '100%',
  transition: 'transform 0.4s cubic-bezier(0.22, 0.61, 0.36, 1)',
  cursor: 'pointer',
  _hover: {
    transform: 'scale3d(1.03,1.03,1.03)',
  },
};

const rootStyles: StyleSystemProps = {
  display: 'flex',
  gridGap: 3,
  flexWrap: 'wrap',
  maxWidth: '100%',
  paddingTop: '2px',
};

const frameStyles: StyleSystemProps = {
  paddingX: 1,
  paddingBottom: 3,
  position: 'relative',
};

const swatchStyles: StyleSystemProps = {
  borderRadius: '100%',
  boxShadow: 'rgb(0 0 0 / 25%) 0px 0px 2px 0px inset',
  position: 'relative',
  _hover: {
    opacity: 0.8,
    _after: {
      opacity: 1,
      borderColor: 'mono10',
    },
    _readOnly: {
      _before: {
        borderTopColor: 'mono10',
      },
    },
  },

  transition: animationTransition('opacity'),
  _after: {
    position: 'absolute',
    content: "' '",
    opacity: 0,
    size: 'calc(100% + 6px)',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    background: 'transparent',
    borderWidth: '2px',
    borderStyle: 'solid',
    borderColor: 'mono14',
    borderRadius: '100%',
    transition: animationTransition('opacity'),
  },
};

export const styles = {
  root: rootStyles,
  swatchFrame: frameStyles,
  swatch: swatchStyles,
  colorCarousel: colorCarouselStyles,
  colorCarouselContainer: colorCarouselContainerStyles,
  arrowButton: arrowButtonStyles,
  colorSwatchContainer: colorSwatchContainerStyles,
  colorSwatchContent: ColorSwatchContentStyles,
  colorSwatchContentOver: ColorSwatchContentOverStyles,
};
